var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
        'vf-padded-container',
        _vm.data.staticClass,
        _vm.data.class,
        {
            'vf-padded-container--bordered': _vm.props.isBordered,
            'vf-x-tight-padding': _vm.props.size === _vm.injections.SIZES.SMALL,
            'vf-xx-loose-padding': _vm.props.size === _vm.injections.SIZES.LARGE
        }
    ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }